import { Company } from '../dashboard_user/types';
import { CompanyFormState } from './components';

export const CATEGORY_OPTIONS = [
  { label: 'Company Overview', value: 'company_overview' },
  { label: 'Financials', value: 'financials' },
  { label: 'Operations', value: 'operations' },
  { label: 'Market & Competition', value: 'market' },
  { label: 'Team & Governance', value: 'team' },
];

export const INITIAL_FORM_STATE: CompanyFormState = {
  name: '',
  domain: '',
  description: '',
  website: '',
  industry: '',
  location: '',
  employees: '',
  founding_year: '',
  sector_id: null,
};

export const REQUIRED_COMPANY_FIELDS: (keyof CompanyFormState)[] = [
  'name',
  'domain',
  'description',
  'website',
  'industry',
  'location',
  'employees',
  'founding_year',
];

export const mapCompanyToForm = (company: Company | null): CompanyFormState => ({
  name: company?.name || '',
  domain: company?.domain || '',
  description: company?.description || '',
  website: company?.website || '',
  industry: company?.industry || '',
  location: company?.location || '',
  employees: company?.employees || '',
  founding_year: company?.founding_year ? String(company.founding_year) : '',
  sector_id: (company as any)?.sector_id ?? null,
});

export const areRequiredFieldsFilled = (form: CompanyFormState): boolean =>
  REQUIRED_COMPANY_FIELDS.every((field) => {
    const value = form[field];
    return value !== null && typeof value === 'string' && value.trim() !== '';
  });

export const getMissingRequiredFields = (form: CompanyFormState): (keyof CompanyFormState)[] =>
  REQUIRED_COMPANY_FIELDS.filter(
    (field) => !form[field] || (form[field] as string).trim() === '',
  );

export const formatMissingFieldsMessage = (missing: (keyof CompanyFormState)[]): string =>
  `Please fill in all required fields: ${missing
    .map((f) =>
      f
        .split('_')
        .map((p) => p.charAt(0).toUpperCase() + p.slice(1))
        .join(' '),
    )
    .join(', ')}`;

export type FlowStep =
  | 'onboarding'
  | 'upload'
  | 'processing'
  | 'form'
  | 'finalization'
  | 'completed'
  | 'overview';
